import { Button, Flex, Heading } from '@chakra-ui/react'
import { userListContext } from 'BrokerTsLib/src/context'
import type { UserPagedQuery } from 'BrokerTsLib/src/dtos'
import { useSearchUsers } from 'BrokerTsLib/src/hooks/useUser'
import { useState } from 'react'

import { ExportType } from 'BrokerTsLib/src/enums'
import { useGetExportUrl } from 'BrokerTsLib/src/hooks'
import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { UserList } from '../../containers/users/UserList'
import { UserListFilter } from '../../containers/users/UserListFilter'
import { Export } from '../../icons'

export const UserListPage = () => {
  const [filter, setFilter] = useState<UserPagedQuery>({
    name: '',
    showInvalid: false,
    pageIndex: 1,
    showAllItems: true,
  })

  const { data, refetch, isLoading, } = useSearchUsers(filter)
  const items = data?.data.items ?? []

  const exportUrl = useGetExportUrl({
    exportType: ExportType.Users
  })

  return (
    <Section>
      <Container>
        <PageContent>
          <userListContext.Provider
            value={{
              loading: isLoading,
              totalCount: data?.data?.totalCount ?? 0,
              currentPage: filter.pageIndex,
              pageSize: filter.pageSize ?? 10,
              showAllItems: filter.showAllItems,
              filter: filter,
              setCurrentPage: (p) => setFilter({ ...filter, pageIndex: p }),
              setPageSize: (p) => setFilter({ ...filter, pageSize: p }),
              updateFilter: (f) => setFilter(f),
              reload: () => refetch(),
            }}
          >
            <PageToolbar
              leftElements={
                <Flex sx={{ gap: 4, alignItems: 'center' }}>
                  <Heading as="h1">Přehled uživatelů</Heading>
                </Flex>
              }
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  <Button
                    colorScheme="gray"
                    onClick={() => window.open(exportUrl)}
                  >
                    <Export />
                    Exportovat
                  </Button>
                </Flex>
              }
            />

            <Flex direction={'column'} gap={4}>
              <UserListFilter />
              <UserList users={items} />
            </Flex>
          </userListContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}
